module.exports = __webpack_public_path__ + "assets/img/empty.75774dd6.png";